import { render, staticRenderFns } from "./XWZ.vue?vue&type=template&id=4e8a3790&scoped=true"
import script from "./XWZ.vue?vue&type=script&lang=js"
export * from "./XWZ.vue?vue&type=script&lang=js"
import style0 from "./XWZ.vue?vue&type=style&index=0&id=4e8a3790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a3790",
  null
  
)

export default component.exports